'use strict';
var bottomPaginationRequest = true;
(function () {
    $(document).ready(function () {
        var homeHeader = $('.home_header');
        var logo = $('.navbar-brand').find('img');
        var whiteLogo = $('.navbar').attr('data-white-logo');
        var defaultLogo = $('.navbar').attr('data-logo');

        if (homeHeader.length > 0) {
            $(window).scroll(function() {
                var scroll = $(window).scrollTop();

                if (scroll >= 20) {
                    homeHeader.removeClass("home_header");
                    logo.attr('src', defaultLogo);
                } else {
                    homeHeader.addClass("home_header");
                    logo.attr('src', whiteLogo);
                }
            });
        }

        $('.close-job-subscribe').on('click', function(){
            $(this).parents('.jobs-page-subscribe').fadeOut();
        });
		
		
		//Keyword search click
		$('#main_sidebar').on('click', '#btn_search_keyword', function(e) {
			e.preventDefault();

			searchItems($('#jobs-filter'),true);
		});
		
		//Sort jobs change
		$('#select_sort').change(function() {
            
			if($(this).hasClass('sort_for_jobs')){
                searchItems($('#jobs-filter'), false)
            }
			else {
                window.location.href = $(this).val();
                //$('#trainings-filter-sort-id').val()
//                var form = $('#jobs-filter');
//                var loading = $('#main_loader').clone();
//                loading.removeClass('no_display');
//                $('#search_list_block').html(loading);
//                $.ajax({
//                    url: form.attr('action'),
//                    method: 'GET',
//                    data:form.serialize(),
//                    success: function(result){
//
//                        $('#search_list_block').html(result.jobs_view);
//                        $('#main_sidebar').html(result.sidebar_view);
//                        history.pushState(null, null, url);
//                    }
//                });
            }
		});
		
		//Scroll top
		$('#btn_scroll_top').on('click', function() {
			$('html, body').animate({scrollTop:0}, 'slow');
		});

		/* Hot job checkbox check */
        $('.job_filter_checkbox').on('click', function () {
            
            $('.job_filter_checkbox').not($(this)).prop('checked', false);
            if($(this).is(':checked')) {
                $(this).val(1);
            }
            else {
                $(this).val(0);
            }

            searchItems($('#jobs-filter'),true);

        });

        const $homeSearchForm = $('#home-search-form');

        $homeSearchForm.attr('action', $homeSearchForm.attr('action') + '#search_list_block');

        $homeSearchForm.on('change + submit', e => {
            const $checkedRadio = $('#jobsfilter-type input[name="search_option"]:checked');
            const action = $homeSearchForm.attr('action').replace(/#(.?)+/i, '');

            if ($checkedRadio.val().trim() != 'companies') {
                $homeSearchForm.attr('action', action + '#search_list_block');
            } else {
                $homeSearchForm.attr('action', action);
            }
        });
    });
})();

const scrollToSearchResults = spead => {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#search_list_block").offset().top
    }, spead || 1000);
};

function searchItems(form, sidebarUpdate) {
  var serializeString = form.serialize();
	var actionUrl = form.attr('action') + '?' + serializeString + '&' + $('#hot_checkbox_form').serialize() + '&' + $('#select_sort').val();

	makeRequest(actionUrl, sidebarUpdate);
    scrollToSearchResults();
}

function makeRequest(url, sidebarUpdate, callback) {
    if (sidebarUpdate) {
        $('#jobs-filter input[type="checkbox"]').attr('disabled', true);
    }

    var loading = $('#main_loader').clone();
    loading.removeClass('no_display');
    $('#search_list_block').html(loading);
    $.ajax({
        url: url,
        method: 'GET',
        success: function (result) {
            $('#search_list_block').html(result.jobs_view);

            if (result.searchCompanyType) {
                $('.search_company_type.right_radius_change').attr('data-href', result.searchCompanyType.rightRadiusChange);
                $('.search_company_type.left_radius_change').attr('data-href', result.searchCompanyType.leftRadiusChange);
            }

            if (sidebarUpdate && result.sidebar_view) {
                $('#main_sidebar').html(result.sidebar_view);
            }

            history.pushState(null, null, url);

            const urlC = new URL(url, 'http://dummy.com');
            const params = new URLSearchParams(urlC.search);
            $('#lang-dropdown .dropdown-menu li a').each(function() {
                var oldHref = $(this).attr('href');
                var newHref = oldHref + '?' + params.toString();
                $(this).attr('href', newHref);
            });

            if (typeof ($("img.lazy").lazyload) === "function") {
                $('img.lazy').lazyload();
            }
        }
    });
}

function showHideScrollTop() {
	
	var y = $(this).scrollTop();
	if (y > 200) {
	    $('#btn_scroll_top').fadeIn();
	} 
	else {
	    $('#btn_scroll_top').fadeOut();
	}
	var scroll_bottom_limit = 275, btn_scroll_top_bottom = '80px';
    var cookie_block = $('.cookie_blog');
    if(!cookie_block.hasClass('hidden')) {
        scroll_bottom_limit = 275 - cookie_block.outerHeight();
        btn_scroll_top_bottom = (cookie_block.outerHeight() + 80) + 'px';
    }
	if($(document).height() - (y + $(window).height()) < scroll_bottom_limit) {
        $('#btn_scroll_top').css('bottom', 353 - ($(document).height() - (y + $(window).height())) + 'px');
	}
	else {
        $('#btn_scroll_top').css('bottom', btn_scroll_top_bottom);
	}
}

function isOnScreen(elem) {
    if( elem.length == 0 ) {
        return;
    }
    var $window = jQuery(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = jQuery(elem);
    var top = $elem.offset().top;
    var height = $elem.height();
    var bottom = top + height;

    if($elem.hasClass('job_current_page')) {
        jobCurrentPage = $elem.data('page');
    }

    return (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

function getNextPage() {
    if( isOnScreen( $( '#bottom_pagination' ) ) ) {
        if(bottomPaginationRequest) {
            bottomPaginationRequest = false;
            var self = $('#bottom_pagination');
            var totalItems = self.data('total');
            var currentItemsCount;
			var nextPageUrl = self.data('href');
			$('.pagination_element').remove();
            $('.bottom_loading').show();
            $.ajax({
                url: nextPageUrl,
                success: function(result){
                    $('.bottom_loading').hide();
                    $('#search_list_block').append(result.jobs_view);
                    var currentPageId = parseInt($('#current_page_id').val());
                    $('#current_page_id').val(currentPageId + 1);
                    currentItemsCount = $('#search_list_block .job-list-item').length;
                    $('.pagination_element_current').first().remove();
                    if(currentItemsCount >= totalItems) {
                        $('.pagination_element').remove();
                    }
                    else {
                        bottomPaginationRequest = true;
                    }
                }
            });
        }
    }
}